import { Box, Button, Divider, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface IPrescriptionCardProps {
  title: string;
  items: { label: string; value: React.ReactNode }[];
  onViewAction?: () => void;
  actionButtonText?: string;
}

export const PrescriptionCard = ({
  title,
  items,
  onViewAction,
  actionButtonText,
}: IPrescriptionCardProps) => {
  const { colors } = useCelleraTheme();
  return (
    <Box
      sx={{
        border: `1px solid ${colors.border.main}`,
        borderRadius: 2,
        p: "16px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: colors.text.primary,
          mb: 1.5,
        }}
      >
        {title}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        {items.map((item) => (
          <Box
            key={item.label}
            sx={{ display: "flex", flexDirection: "row", gap: 2 }}
          >
            <Box sx={{ width: "35%", flexShrink: 0 }}>
              <Typography
                variant="body2"
                sx={{
                  color: colors.text.secondary,
                  fontWeight: 500,
                }}
              >
                {item.label}
              </Typography>
            </Box>
            <Box sx={{ width: "65%", flex: 1 }}>{item.value}</Box>
          </Box>
        ))}
      </Box>

      {onViewAction && (
        <Button
          className="py-0 px-3 rounded-full"
          sx={{
            backgroundColor: colors.background.paper,
            color: colors.text.primary,
            border: `1px solid ${colors.border.main}`,
          }}
          onClick={onViewAction}
        >
          {actionButtonText}
        </Button>
      )}
    </Box>
  );
};
